<script setup lang="ts">

import { formatShort } from '@/models/formatNumber.ts'

// Define the props your component expects
defineProps({
  amount: {
    type: Number,
    required: true
  },
  noPlus: {
    type: Boolean,
    default: false
  },
  allowZero: {
    type: Boolean,
    default: false
  },
  fractions: {
    type: Boolean,
    default: false
  }
});

</script>

<template>
  <span v-if="amount < 0" class="text-red-500 align-middle pl-1 pr-0.5">
    {{ formatShort(amount) }}
  </span>
  <span v-else-if="amount > 0" class="text-green-500 align-middle pr-0.5">
    <span v-if="!noPlus" class="pl-0.5">+</span><span v-else class="pl-0.5"></span><span v-if="amount === 666666">?</span><span v-else>
    {{ formatShort(amount) }}
  </span>
  </span>
  <span v-else-if="allowZero" class="text-gray-500 align-middle pr-0.5 pl-0.5">
    0
  </span>
</template>

<style scoped lang="scss">

</style>